import { ACTION, CreateNewDraft, CreateNewDraftFailure } from './action-types';
import { CaseState } from '../types-store';
import { ActionMap } from 'app/area/case';

export const reducers: ActionMap = {

  [ACTION.CREATE_NEW_DRAFT]: (state: CaseState, action: CreateNewDraft): CaseState => {
    return {
      ...state,
      schema: undefined,
      uiDefinition: undefined,
      fetching: true,
      activeChildItem: undefined,
      editing: undefined
    };
  },
  
  [ACTION.CREATE_NEW_DRAFT_FAILURE]: (state: CaseState, action: CreateNewDraftFailure): CaseState => {
    return {
      ...state,
      ...{
        fetching: false
      }
    };

  }  

};
